<template>
	<c-dialog ref="dialog" title="选择审批人" height="50vh" :close-button="false" @resolve="stop => reject ? rejectHandle(stop) : resolveHandle(stop)">
		<c-form>
			<c-form-item v-if="!reject" label="选择审批人" required>
				<div class="staff-list flex-wrap">
					<member-icon v-for="(item, i) in approverList" :key="i" :icon="item.head_photo" :name="item.name" text :current="currentApprover == item.id" @click="currentApprover = item.id"></member-icon>
				</div>
			</c-form-item>
			<c-form-item v-if="!reject" label="选择抄送人">
				<div class="staff-list flex-wrap">
					<member-icon v-for="(item, i) in currentCarbon" :key="i" :icon="item.head_photo" :name="item.name" text @delete="currentCarbon.splice(i, 1)"></member-icon>
					<div class="add flex-center" @click="carbonHandle"><i class="tf">&#xe727;</i></div>
				</div>
			</c-form-item>
			<c-form-item v-if="reject" label="驳回原因" required>
				<c-input v-model="remark" type="textarea" placeholder="驳回原因写这里..."></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'flowApprove',

		props: {
			reject: Boolean
		},

		data() {
			return {
				remark: '',
				approverList: [],
				currentApprover: '',
				currentCarbon: []
			}
		},

		methods: {
			open(data = {}) {
				this.approverList = data.approver;
				if (!this.reject && this.approverList.length == 1) {
					this.currentApprover = this.approverList[0].id;
				}
				this.$refs.dialog.open();
			},

			carbonHandle() {
				this.globalDialog('staffSelector', {
					props: {
						multiple: true
					}
				}, data => {
					this.currentCarbon = this.currentCarbon.concat(data.filter(item => !this.currentCarbon.find(temp => temp.id == item.id)));
				});
			},

			resolveHandle(stop) {
				if (!this.currentApprover) {
					stop();
					this.$message({
						message: '请选择审批人'
					});
					return;
				}

				this.$emit('resolve', {
					approver: this.currentApprover,
					carbon: this.currentCarbon.map(item => item.id).join(',')
				});
			},

			rejectHandle(stop) {
				if (!this.remark.trim()) {
					stop();
					this.$message({
						message: '请填写驳回原因'
					});
					return;
				}

				this.$emit('resolve', {
					remark: this.remark.trim()
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.staff-list {
		column-gap: .3rem;
		row-gap: .1rem;

		.add {
			box-sizing: border-box;
			width: .8rem;
			height: .8rem;
			border: 1px dashed #aaa;
			border-radius: 50%;
			font-size: .4rem;
			color: #aaa;
		}
	}
</style>
